import OathboundFrame from "@/components/OathboundFrame/OathboundFrame";
import "./PurchaseVerification.css";

export default function PurchaseVerification() {
  return (
    <main
      className="purchase-verification-page"
      aria-labelledby="purchase-verification-title"
      aria-busy="true"
    >
      <OathboundFrame />

      <section className="purchase-verification-content" role="status" aria-live="polite">
        <div className="purchase-verification-panel">
          <img
            className="purchase-verification-hero"
            src="/media/images/enter_logo.avif"
            alt="The Oath of the Unhuan"
          />
          <span className="purchase-verification-spinner" aria-hidden="true" />
          <h1 id="purchase-verification-title">Confirming your payment</h1>
          <p>Please keep this page open while we prepare your receipt.</p>
        </div>
      </section>
    </main>
  );
}
